/*
  Custom element: <promo-carousel>
  Usado por snippets/promo-image.liquid y snippets/promo-card.liquid (sep 2026).

  Reemplaza al script inline anterior (setInterval + querySelector una sola vez
  al cargar la página). El problema del script anterior: cuando los filtros o
  la paginación reemplazan el HTML de la grilla (innerHTML / insertAdjacentHTML),
  los navegadores NO ejecutan los <script> que vienen dentro de ese HTML nuevo,
  así que el carrusel quedaba congelado en la primera imagen tras filtrar.

  Un custom element sí se "reactiva" (connectedCallback) cada vez que su HTML
  se inserta en el DOM, sin importar el método usado (innerHTML incluido), así
  que el carrusel vuelve a arrancar solo.

  Atributos:
    data-rotate-ms - milisegundos entre cada cambio de slide.
  Estructura esperada: hijos directos con la clase "promo-carousel__slide",
  uno de ellos con la clase "is-active" (la que se muestra primero).
*/
if (!customElements.get('promo-carousel')) {
  customElements.define('promo-carousel', class extends HTMLElement {
    connectedCallback() {
      var slides = this.querySelectorAll(':scope > .promo-carousel__slide');
      if (slides.length < 2) return;

      var current = 0;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) {
          current = i;
          break;
        }
      }

      var ms = parseInt(this.dataset.rotateMs, 10) || 5000;
      var self = this;
      this._timer = setInterval(function () {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, ms);
    }

    disconnectedCallback() {
      clearInterval(this._timer);
    }
  });
}
